"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTrxe = exports.trxeUseableDef = void 0;
const KetteSerieType_1 = require("./KetteSerieType");
const schemaVersions_1 = require("../schemaVersions");
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
exports.trxeUseableDef = {
    parent: schemaVersions_1.ketteLatestUseableDef,
    validation: {
        KetteSerieType: (v) => v === KetteSerieType_1.KetteSerieType.trxe,
        ContractedLength: (q) => Boolean(q),
        EffektiveLaenge: (q) => Boolean(q),
    },
};
exports.isTrxe = echain_shared_modelling_1.UseableUtil.createGuard(exports.trxeUseableDef);
//# sourceMappingURL=Trxe.js.map